import { render, staticRenderFns } from "./AlgLoginButton.vue?vue&type=template&id=f845cc4c&scoped=true&"
import script from "./AlgLoginButton.vue?vue&type=script&lang=js&"
export * from "./AlgLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./AlgLoginButton.vue?vue&type=style&index=0&id=f845cc4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f845cc4c",
  null
  
)

export default component.exports